module.exports = __webpack_public_path__ + "static/c2-9d2e78a74a0a67a272fbdc4f8fc9852b.webp";